import React from 'react';
import i18n, { getDateFormatOptions } from '@/utils/i18n';
import { Table } from 'reactstrap';
import { FaCalendarAlt } from 'react-icons/fa';

type TimestampUpdatesProps = {
  oldTimestamp: { Timestamp: string };
  newTimestamp: { Timestamp: string };
};

const TimestampUpdates = ({
  oldTimestamp,
  newTimestamp,
}: TimestampUpdatesProps) => {
  const oldParsedTimestamp = new Date(
    oldTimestamp.Timestamp,
  ).toLocaleDateString(i18n.language, getDateFormatOptions(true));

  const newParsedTimestamp = new Date(
    newTimestamp.Timestamp,
  ).toLocaleDateString(i18n.language, getDateFormatOptions(true));

  return (
    <Table style={{ width: '100%', tableLayout: 'fixed' }}>
      <thead>
        <tr>
          <th>{i18n.t('Common:type')}</th>
          <th>{i18n.t('Common:dateTime')}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style={{ width: '50%' }}>
            <FaCalendarAlt size={40} />
          </td>
          <td style={{ width: '50%' }}>
            {oldParsedTimestamp} ↓
            <br />
            {newParsedTimestamp}
          </td>
        </tr>
      </tbody>
    </Table>
  );
};

export default TimestampUpdates;
